

















































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { Insured } from '@/modules/Insured/interfaces/insured'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import {
  insuredRelationship, relationKeys, relationValues,
  insuredGender, genderKeys, genderValues,
  insuredIncludedOrExcluded, includedKeys, includedValues,
  insuredEducationLevel, educationKeys, educationValues,
  insuredLicenseStatus, licenseKeys, licenseValues,
  insuredMaritalStatus, maritalKeys, maritalValues,
  insuredDUI, duiKeys, duiValues,
  insuredSROrFR, srKeys, srValues,
  insuredHealthClass, healthKeys, healthValues
} from '@/modules/Insured/helpers/insured'

@Component({
  components: {
    FoldingCard,
    AppDialog
  }
})
export default class InsuredDetailDetail extends Vue {
  @Prop({ type: Object as () => Insured }) readonly insured!: Insured

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  contactInfoCard = [
    { title: 'First Name', keyName: 'firstName', content: '-' },
    { title: 'Soc Sec #', keyName: 'socSec', content: '-' },
    { title: 'Middle Name', keyName: 'middleName', content: '-' },
    { title: 'Date of Birth', keyName: 'dateOfBirth', content: '-' },
    { title: 'Last Name', keyName: 'lastName', content: '-' },
    { title: 'Marital Status', keyName: 'maritalStatus', content: '-' },
    { title: 'Education Level', keyName: 'educationLevel', content: '-' }
  ]

  driverInfoCard = [
    { title: 'Drivers License Number', keyName: 'driversLicenseNumber', content: '-' },
    { title: 'License Status', keyName: 'licenseStatus', content: '-' },
    { title: 'Accidents/Violations', keyName: 'accidentsOrViolations', content: '-' },
    { title: 'License State', keyName: 'licenseState', content: '-' },
    { title: 'Mature Driver', keyName: 'matureDriver', content: '-' },
    { title: 'Date Licensed', keyName: 'dateLicensed', content: '-' },
    { title: 'Student Over 100 Miles Away', keyName: 'studentFarAway', content: '-' },
    { title: 'Good Driver', keyName: 'goodDriver', content: '-' },
    { title: 'Good Student', keyName: 'goodStudent', content: '-' },
    { title: 'Driver Training', keyName: 'driverTraining', content: '-' },
    { title: 'Defensive Driver Course Date', keyName: 'defensiveDriverCourseDate', content: '-' },
    { title: 'DUI Conviction in The Past 5 Years', keyName: 'dui', content: '-' },
    { title: 'DDC Expired Date', keyName: 'ddcExpiredDate', content: '-' },
    { title: 'SR22 or FR44', keyName: 'srOrFr', content: '-' }
  ]

  employmentInfoCard = [
    { title: 'Current Employer Information', keyName: 'currentEmployerInformation', content: '-' },
    { title: 'Previous Employer Information', keyName: 'previousEmployerInformation', content: '-' },
    { title: 'Employer Phone', keyName: 'employerPhone', content: '-' },
    { title: 'Occupation Class Code', keyName: 'occupationClassCode', content: '-' },
    { title: 'Title', keyName: 'title', content: '-' },
    { title: 'Occupation Years', keyName: 'occupationYears', content: '-' }
  ]

  healthInfoCard = [
    { title: 'Expected Annual Income', keyName: 'expectedAnnualIncome', content: '-' },
    { title: 'Tobacco User', keyName: 'tobaccoUser', content: '-' },
    { title: 'Additional Income', keyName: 'additionalIncome', content: '-' },
    { title: 'Receives Medicare or Medicaid', keyName: 'receivesMedicareOrMedicaid', content: '-' },
    { title: 'Anticipated Adjusted Gross Income', keyName: 'aagIncome', content: '-' },
    { title: 'Receives Social Security Benefits', keyName: 'receiveSocialSecurityBenefits', content: '-' },
    { title: 'Employer Health Insurance', keyName: 'employerHealthInsurance', content: '-' },
    { title: 'Needs Insurance?', keyName: 'needsInsurance', content: '-' },
    { title: 'Employee Only Health Insurance Amount', keyName: 'employeeOHIAmount', content: '-' },
    { title: 'Pre-Existing Conditions', keyName: 'preExistingConditions', content: '-' },
    { title: 'Spouse\'s Employer Offers Insurance?', keyName: 'spouseEOInsurance', content: '-' },
    { title: 'Medications', keyName: 'medications', content: '-' },
    { title: 'Spouse Employee ONLY Health Ins Amount', keyName: 'spouseEOHIAmount', content: '-' },
    { title: 'Weight', keyName: 'weight', content: '-' },
    { title: 'Height', keyName: 'height', content: '-' },
    { title: 'Health Class', keyName: 'healthClass', content: '-' }
  ]

  additionalInfoCards: {
    title: string;
    items: {[key: string]: string;}[]
  }[] = []

  insuredRelationship = insuredRelationship
  relationKeys = relationKeys
  relationValues = relationValues
  insuredGender = insuredGender
  genderKeys = genderKeys
  genderValues = genderValues
  insuredIncludedOrExcluded = insuredIncludedOrExcluded
  includedKeys = includedKeys
  includedValues = includedValues
  insuredEducationLevel = insuredEducationLevel
  educationKeys = educationKeys
  educationValues = educationValues
  insuredLicenseStatus = insuredLicenseStatus
  licenseKeys = licenseKeys
  licenseValues = licenseValues
  insuredMaritalStatus = insuredMaritalStatus
  maritalKeys = maritalKeys
  maritalValues = maritalValues
  insuredDUI = insuredDUI
  duiKeys = duiKeys
  duiValues = duiValues
  insuredSROrFR = insuredSROrFR
  srKeys = srKeys
  srValues = srValues
  insuredHealthClass = insuredHealthClass
  healthKeys = healthKeys
  healthValues = healthValues

  get policyRoute () {
    return {
      name: 'PolicyDetailDetail',
      params: {
        id: this.insured.policy.id
      }
    }
  }

  get quoteRoute () {
    return {
      name: 'QuoteDetailDetail',
      params: {
        id: this.insured.quote.id
      }
    }
  }

  @Watch('insured')
  onInsuredUpdated (val: any) {
    const { contactInfoCard, driverInfoCard, employmentInfoCard, healthInfoCard } = this
    this.contactInfoCard = contactInfoCard.map(item => {
      item.content = val[item.keyName]
      if (item.keyName === 'dateOfBirth') {
        item.content = val[item.keyName] ? dateToDisplay(+val[item.keyName]) : ''
      }
      return item
    })
    this.driverInfoCard = driverInfoCard.map(item => {
      item.content = val[item.keyName]
      return item
    })
    this.employmentInfoCard = employmentInfoCard.map(item => {
      item.content = val[item.keyName]
      return item
    })
    this.healthInfoCard = healthInfoCard.map(item => {
      item.content = val[item.keyName]
      return item
    })
  }

  mounted () {
    this.onInsuredUpdated(this.insured)
  }
}
